import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d54jgt1fvv2fnl62a84g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contact" className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#C9A88A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            تواصلي معي
          </h2>
          <div className="w-24 h-1 bg-[#D4AF7A] mx-auto mb-4"></div>
          <p className="text-[#3D3D3D]/70 text-lg max-w-2xl mx-auto">
            أسعد دائماً بالإجابة على استفساراتك ومساعدتك في اختيار القطعة المثالية
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-[#F8F6F0] p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-[#3D3D3D] mb-6">معلومات التواصل</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF7A] rounded-full flex-shrink-0">
                    <i className="ri-mail-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#3D3D3D] mb-1">البريد الإلكتروني</h4>
                    <p className="text-[#3D3D3D]/70">info@luxuryproductsbymaram.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF7A] rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#3D3D3D] mb-1">الهاتف</h4>
                    <p className="text-[#3D3D3D]/70" dir="ltr">+966 50 123 4567</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF7A] rounded-full flex-shrink-0">
                    <i className="ri-instagram-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#3D3D3D] mb-1">إنستغرام</h4>
                    <p className="text-[#3D3D3D]/70">@luxuryproductsbymaram</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF7A] rounded-full flex-shrink-0">
                    <i className="ri-time-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#3D3D3D] mb-1">ساعات العمل</h4>
                    <p className="text-[#3D3D3D]/70">السبت - الخميس: 10:00 ص - 8:00 م</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 flex items-center justify-center bg-[#D4AF7A] rounded-full hover:bg-[#C9A88A] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl text-white"></i>
              </a>
              <a
                href="https://wa.me/966501234567"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 flex items-center justify-center bg-[#D4AF7A] rounded-full hover:bg-[#C9A88A] transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl text-white"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 flex items-center justify-center bg-[#D4AF7A] rounded-full hover:bg-[#C9A88A] transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-2xl text-white"></i>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
            <div>
              <label htmlFor="name" className="block text-[#3D3D3D] font-medium mb-2">
                الاسم
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-[#D4AF7A]/30 focus:border-[#D4AF7A] focus:outline-none bg-[#F8F6F0] text-[#3D3D3D] text-sm"
                placeholder="أدخلي اسمك"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-[#3D3D3D] font-medium mb-2">
                البريد الإلكتروني
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-[#D4AF7A]/30 focus:border-[#D4AF7A] focus:outline-none bg-[#F8F6F0] text-[#3D3D3D] text-sm"
                placeholder="example@email.com"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block text-[#3D3D3D] font-medium mb-2">
                رقم الهاتف
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-[#D4AF7A]/30 focus:border-[#D4AF7A] focus:outline-none bg-[#F8F6F0] text-[#3D3D3D] text-sm"
                placeholder="+966 50 123 4567"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-[#3D3D3D] font-medium mb-2">
                رسالتك
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={500}
                rows={5}
                className="w-full px-4 py-3 rounded-lg border border-[#D4AF7A]/30 focus:border-[#D4AF7A] focus:outline-none bg-[#F8F6F0] text-[#3D3D3D] resize-none text-sm"
                placeholder="كيف يمكنني مساعدتك؟"
              ></textarea>
              <p className="text-xs text-[#3D3D3D]/50 mt-1">الحد الأقصى: 500 حرف</p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
                تم إرسال رسالتك بنجاح! سأتواصل معك قريباً.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#D4AF7A] text-white px-8 py-4 rounded-full hover:bg-[#C9A88A] transition-colors whitespace-nowrap font-medium text-lg disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
            >
              {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
